export enum EStatusCode {
  NotFound = 'urlNotFound',
}

interface IStatusCodeInfo {
  key: 'statusCode';
  code: EStatusCode;
  message: string;
}

export type TErrorInfo = IStatusCodeInfo;
